var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 38.865 58.283",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 38.865,
    height: 58.283,
    fill: "#e2bd69"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2451",
    "data-name": "Path 2451",
    d: "M19.546,50.926c-1.943-2.5-3.675-4.731-5.406-6.961C10.795,39.651,7.363,35.4,4.125,31.009-.542,24.677-1.324,17.768,2.164,10.722,5.678,3.62,11.7-.065,19.614,0A18.194,18.194,0,0,1,36.686,10.714c3.439,6.948,2.789,13.836-1.814,20.074-4.873,6.6-10.027,13-15.053,19.491a3.428,3.428,0,0,0-.272.646m-.088-40.24a8.965,8.965,0,1,0,8.962,9.064,8.978,8.978,0,0,0-8.962-9.064",
    transform: "translate(0 0)",
    fill: "#e2bd69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2452",
    "data-name": "Path 2452",
    d: "M2.817,86.729A14.632,14.632,0,0,0,9.374,88.97a63.062,63.062,0,0,0,23.58-.6,27.98,27.98,0,0,0,3.413-1.257c0-.162.005-.324.008-.486a13.35,13.35,0,0,0-2.386-1.047c-2.258-.513-4.54-.924-6.824-1.313-.82-.14-1.642-.234-1.526-1.3s.948-1.1,1.769-.932c2.688.547,5.386,1.056,8.046,1.716a6.159,6.159,0,0,1,2.333,1.307,2.119,2.119,0,0,1-.043,3.537,12.931,12.931,0,0,1-3.921,1.835A55.329,55.329,0,0,1,15,91.8,89.7,89.7,0,0,1,4.725,90.133a7.456,7.456,0,0,1-2.851-1.417,2.193,2.193,0,0,1,0-3.793A9.657,9.657,0,0,1,5.1,83.384a69.4,69.4,0,0,1,7.083-1.319,1.705,1.705,0,0,1,1.385.887c.271.816-.386,1.162-1.172,1.3-2.281.4-4.565.8-6.824,1.308a17.864,17.864,0,0,0-2.754,1.169",
    transform: "translate(-0.323 -33.755)",
    fill: "#e2bd69"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.790140dd925d315511d1ad7ebacd5680.svg";
export { ForwardRef as ReactComponent };